import { Injectable } from '@angular/core';

import { HttpService } from './http.service';
import { SessionService } from './session.service';

import { Login } from '../entities/login.entity';
import { ContratosUser } from '../entities/ContratosUser.entity';
import { PrimerAcceso } from '../entities/primerAcceso.entity';
import { UsuarioUpdate } from '../entities/usuarioUpdate.entity';
import { Contrato } from '../entities/contrato.entity';
import { Impresos } from '../entities/impresos.entity';
import { ResetPassword } from '../entities/resetPassword.entity';
import { RegisterUser } from '../entities/RegisterUser.entity';
import { Contacto } from '../entities/contacto.entity';
import { SimuladorConsumos } from '../entities/simuladorConsumos.entity';
import { SimuladorConsumosDet } from '../entities/simuladorConsumoDet.entity';
import { FacturaSeleccion } from '../entities/facturaSeleccion.entity';
import { Domiciliacion } from '../entities/domiciliacion.entity';
import { FacturasFiltro } from '../entities/facturasFiltro';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpService: HttpService, private sessionService: SessionService) { }

  public registerUser(explotacion: string, user: RegisterUser) {
    return this.httpService.httpPutNoAuth(
      user,
      this.sessionService.apiServer + 'UsuariosOnline/Registro?explotacionCodigo=' + explotacion
    );
  }

  public login(explotacion: string, user: Login) {
    return this.httpService.httpPost(
      user,
      this.sessionService.apiServer + 'UsuariosOnline/Login?explotacionCodigo=' + explotacion,
      true,
      false
    );
  }

  public authenicate(user: ContratosUser) {
    return this.httpService.httpPost(user, this.sessionService.apiServer + 'users/Authenicate', false);
  }

  public resetPassword(user: ResetPassword) {
    return this.httpService.httpPost(
      user,
      this.sessionService.apiServer + 'UsuariosOnline/ResetearPassword?explotacionCodigo=' + user.Poblacion,
      true, false
    );
  }

  public FirstAccess(explotacion: string, user: PrimerAcceso) {
    return this.httpService.httpPut(
      user,
      this.sessionService.apiServer + 'UsuariosOnline/PrimerAcceso?explotacionCodigo=' + explotacion
    );
  }

  public getExplotaciones() {
    return this.httpService.httpGet(this.sessionService.apiServer + 'GetExplotacionesViewModel');
  }

  public getImpresos(explotacion: string) {
    return this.httpService.httpGet(
      this.sessionService.apiServer + 'GetImpresosViewModel?explotacionCodigo=' + explotacion
    );
  }

  public getSimuladorConsumos(explotacion: string, contrato: number) {
    return this.httpService.httpGet(
      this.sessionService.apiServer + 'TextosSimulacion?explotacionCodigo=' + explotacion + '&codContrato=' + contrato,
      true
    );
  }

  public generarSimulacion(explotacion: string, datos: SimuladorConsumos) {
    return this.httpService.httpPut(
      datos,
      this.sessionService.apiServer + 'GeneraSimulacion?explotacionCodigo=' + explotacion
    );
  }

  public generarSimulacionDetallado(explotacion: string, datos: SimuladorConsumosDet) {
    return this.httpService.httpPut(
      datos,
      this.sessionService.apiServer + 'GeneraSimulacionDetallado?explotacionCodigo=' + explotacion
    );
  }

  public descargarSimulacion(explotacion: string, datos: SimuladorConsumos) {
    return this.httpService.putDownloadFile(
      datos,
      this.sessionService.apiServer + 'DescargaSimulacion?explotacionCodigo=' + explotacion
    );
  }

  public contacto(explotacion: string, contacto: Contacto) {
    return this.httpService.httpPut(
      contacto,
      this.sessionService.apiServer + 'UsuariosOnline/Contacto?explotacionCodigo=' + explotacion
    );
  }

  public contactoPublico(explotacion: string, contacto: Contacto) {
    return this.httpService.httpPut(
      contacto,
      this.sessionService.apiServer + 'UsuariosOnline/ContactoPublico?explotacionCodigo=' + explotacion
    );
  }

  public descargaFactura(factura: FacturaSeleccion) {
    return this.httpService.putDownloadFile(factura, this.sessionService.apiServer + 'DownloadPdfFile');
  }

  public domiciliarFactura(explotacion: string, datos: Domiciliacion) {
    return this.httpService.httpPut(
      datos,
      this.sessionService.apiServer + 'Domiciliacion?explotacionCodigo=' + explotacion
    );
  }

  public descargarMandato(explotacion: string, datos: Domiciliacion) {
    return this.httpService.putDownloadFile(
      datos,
      this.sessionService.apiServer + 'Mandato?explotacionCodigo=' + explotacion
    );
  }

  public correspondenciaFactura(explotacion: string, datos: Domiciliacion) {
    return this.httpService.httpPut(
      datos,
      this.sessionService.apiServer + 'Correspondencia?explotacionCodigo=' + explotacion
    );
  }

  public upload(explotacion: string, files) {
    return this.httpService.httpPostOptions(
      files,
      this.sessionService.apiServer + 'AutoLectura?explotacionCodigo=' + explotacion
    );
  }

  public uploadBaja(explotacion: string, files) {
    return this.httpService.httpPostOptions(
      files,
      this.sessionService.apiServer + 'Baja?explotacionCodigo=' + explotacion
    );
  }

  public getImages() {
    return this.httpService.httpGet(this.sessionService.apiServer + 'getimages');
  }

  public updateuser(explotacion: string, user: UsuarioUpdate) {
    return this.httpService.httpPut(
      user,
      this.sessionService.apiServer + 'DatosUsuario?explotacionCodigo=' + explotacion
    );
  }

  public ObtenerFacturas(explotacion: string, facturas: FacturasFiltro) {
    return this.httpService.httpPost(
      facturas,
      this.sessionService.apiServer + 'getFacturas?explotacionCodigo=' + explotacion
    );
  }

  public uploadAveria(explotacion: string, files) {
    return this.httpService.httpPost(
      files,
      this.sessionService.apiServer + 'AveriasMobile?explotacionCodigo=' + explotacion
    );
  }

  public descargaImpresos(explotacion: string, impreso: Impresos) {
    return this.httpService.putDownloadFileNoAuth(
      impreso,
      this.sessionService.apiServer + 'DownloadImpresoPdfFileGet?explotacionCodigo=' + explotacion
    );
  }

  public esPagadorOInactivo(contrato: Contrato, login: string): boolean {
    return contrato.FAnulacion !== null ? true
      : contrato.PagadorDocIden === undefined ? false
        : contrato.PagadorDocIden.toUpperCase() === contrato.TitularDocIden.toUpperCase() ? false
          : contrato.PagadorDocIden.toUpperCase() === login.toUpperCase();
  }
}
